import { getCookieByName } from '../utils/functions';
import { useSelector } from 'react-redux';

export function useEnableZeroSphere() {
  const enableZeroSphereCookie = getCookieByName('enableZeroSphere', true);
  const enableZeroSphere = useSelector(
    (state: any) => state.config.prescriptionModule?.enableZeroSphere
  );
  const brand = useSelector((state: any) => state.config.brand);

  if (enableZeroSphereCookie !== null) {
    return enableZeroSphereCookie as boolean;
  }

  if (enableZeroSphere !== null && enableZeroSphere !== undefined) {
    return enableZeroSphere as boolean;
  }
  return false;
}
